/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionDocumentList } from './PalReauthSubmissionDocumentList';
import {
    PalReauthSubmissionDocumentListFromJSON,
    PalReauthSubmissionDocumentListFromJSONTyped,
    PalReauthSubmissionDocumentListToJSON,
    PalReauthSubmissionDocumentListToJSONTyped,
} from './PalReauthSubmissionDocumentList';

/**
 * 
 * @export
 * @interface GetPalReauthSubmissionDocuments200Response
 */
export interface GetPalReauthSubmissionDocuments200Response {
    /**
     * 
     */
    data?: PalReauthSubmissionDocumentList;
}

/**
 * Check if a given object implements the GetPalReauthSubmissionDocuments200Response interface.
 */
export function instanceOfGetPalReauthSubmissionDocuments200Response(value: object): value is GetPalReauthSubmissionDocuments200Response {
    return true;
}

export function GetPalReauthSubmissionDocuments200ResponseFromJSON(json: any): GetPalReauthSubmissionDocuments200Response {
    return GetPalReauthSubmissionDocuments200ResponseFromJSONTyped(json, false);
}

export function GetPalReauthSubmissionDocuments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPalReauthSubmissionDocuments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionDocumentListFromJSON(json['data']),
    };
}

export function GetPalReauthSubmissionDocuments200ResponseToJSON(json: any): GetPalReauthSubmissionDocuments200Response {
    return GetPalReauthSubmissionDocuments200ResponseToJSONTyped(json, false);
}

export function GetPalReauthSubmissionDocuments200ResponseToJSONTyped(value?: GetPalReauthSubmissionDocuments200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionDocumentListToJSON(value['data']),
    };
}

